.vertical-tabs-container {
    display: flex;
    flex-direction: column;
    gap: 4px;
    padding: 16px 12px;
    box-sizing: border-box;
}

.vertical-tab {
    display: flex;
    padding: 8px 12px;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    cursor: pointer;
    transition: all 0.2s ease;
    min-width: 0;
    background: transparent;
}

.vertical-tab-content {
    display: flex;
    gap: 8px;
    min-width: 0;
    align-items: center;
}

.vertical-tab:hover {
    background-color: var(--skeleton-grey);
    border-radius: 4px;
}

/* Backup for browsers that do not support :focus-visible */
.vertical-tab:focus {
    background-color: var(--skeleton-grey);
    outline: var(--blue) solid 1px;
    outline-offset: 0;
    border-radius: 4px;
}

/* Removes focus style on non-keyboard input (i.e. mouse click) */
.vertical-tab:focus:not(:focus-visible) {
    outline: none;
}

/* Adds focus style only on keyboard input for browsers that support :focus-visible */
.vertical-tab:focus-visible {
    background-color: var(--skeleton-grey);
    outline: var(--blue) solid 1px;
    outline-offset: 0;
    border-radius: 4px;
}

.vertical-tab--selected {
    composes: vertical-tab;
    background-color: var(--skeleton-grey);
    border-radius: 4px;
}

.vertical-tab--icon-only {
    padding: 8px 0;
    justify-content: center;
}

.vertical-tab--disabled {
    opacity: 0.6;
    pointer-events: none;
}
